export interface TinySearchRow {
    date?: string | null;
    description?: string | null;
    voucherNo?: string | null;
    invoiceNo?: string | null;
    details?: string | null;
    chequeNo?: string | null;
    amount?: number | null;
    columnValues?: Record<string, number> | null;
}

function amountText(value: number): string[] {
    const abs = Math.abs(value);
    const fixed = abs.toFixed(2);
    const grouped = abs.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
    return [String(value), fixed, grouped, value < 0 ? `(${grouped})` : grouped];
}

/** Tiny Mode 明细搜索：日期、摘要、凭证、发票号、明细、金额。空关键字匹配全部。 */
export function tinyRowMatchesQuery(row: TinySearchRow, query: string): boolean {
    const q = query.trim().toLowerCase();
    if (!q) return true;
    const qNum = q.replace(/,/g, '');
    const texts = [row.date, row.description, row.voucherNo, row.invoiceNo, row.details, row.chequeNo]
        .filter((v) => v != null && String(v).trim() !== '')
        .map((v) => String(v).toLowerCase());
    if (texts.some((text) => text.includes(q))) return true;

    const amounts: number[] = [];
    if (row.amount != null && row.amount !== 0) amounts.push(Number(row.amount));
    if (row.columnValues) {
        for (const value of Object.values(row.columnValues)) {
            if (value != null && value !== 0) amounts.push(Number(value));
        }
    }
    return amounts.some((amount) => amountText(amount).some((text) => text.toLowerCase().replace(/,/g, '').includes(qNum)));
}

export interface EditInvoiceSearchRow {
    date?: string | null;
    description?: string | null;
    voucherNo?: string | null;
    invoiceNo?: string | null;
    invoiceDate?: string | null;
    chequeNo?: string | null;
    details?: string | null;
    drCrItems?: Array<{
        columnKey?: string | null;
        amount?: string | null;
    }> | null;
}

/**
 * GL Edit 行搜索：字段同 Tiny，另含 invoiceDate、DR/CR 金额与科目名（英文/中文/代码）。
 * accountLabelsByKey：columnKey → 展示名（可含中文）。
 */
export function editInvoiceRowMatchesQuery(
    row: EditInvoiceSearchRow,
    query: string,
    accountLabelsByKey?: Map<string, string> | null,
): boolean {
    const q = query.trim().toLowerCase();
    if (!q) return true;

    const columnValues: Record<string, number> = {};
    for (const [idx, item] of (row.drCrItems || []).entries()) {
        const raw = String(item?.amount ?? '').replace(/,/g, '').trim();
        if (!raw) continue;
        const n = Number(raw);
        if (Number.isFinite(n) && n !== 0) columnValues[`a${idx}`] = n;
    }

    if (tinyRowMatchesQuery({
        date: row.date,
        description: row.description,
        voucherNo: row.voucherNo,
        invoiceNo: row.invoiceNo,
        details: row.details,
        chequeNo: row.chequeNo,
        columnValues,
    }, query)) {
        return true;
    }

    const invoiceDate = (row.invoiceDate || '').trim().toLowerCase();
    if (invoiceDate && invoiceDate.includes(q)) return true;

    if (!accountLabelsByKey || accountLabelsByKey.size === 0) return false;
    for (const item of row.drCrItems || []) {
        const key = (item?.columnKey || '').trim();
        if (!key) continue;
        const label = (accountLabelsByKey.get(key) || '').toLowerCase();
        if (label && label.includes(q)) return true;
        if (key.toLowerCase().includes(q)) return true;
    }
    return false;
}
